var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cta-button',_vm._b({attrs:{"is-solid":"","has-icon":"","palette":_vm.palette},on:{"click":function($event){return _vm.$emit('click', $event)}},scopedSlots:_vm._u([{key:"icon",fn:function(ref){
var classes = ref.classes;
return [_c('font-awesome-icon',{class:classes,attrs:{"icon":"plus","transform":"shrink-4 left-2","fixed-width":""}})]}}])},'cta-button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }